//
//
//
//
//
//
//
//
//

import { downloadFlowerDesign } from '@/api/flowerDesign';
export default {
  name: 'V',
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  methods: {
    // 下载设计稿
    downloadFile: function downloadFile() {
      var data = {
        uuids: this.rowData['flowerDesignId']
      };
      downloadFlowerDesign(data);
    }
  }
};